import { __rest } from 'tslib';
import React from 'react';
import { extractMarginProps, extractPaddingProps, extractDimensionProps } from '@10d/tend-ui-styling';
import { useColor } from '@10d/tend-ui-theme';
import { Root } from './styled.js';

const Paragraph = React.forwardRef((_a, ref) => {
    var { size = 'medium', fontWeight = 500, color, textAlign, uppercase, className, whiteSpace } = _a, props = __rest(_a, ["size", "fontWeight", "color", "textAlign", "uppercase", "className", "whiteSpace"]);
    const $color = useColor(color);
    const _b = extractMarginProps(props), { rest: withoutMargins } = _b, margins = __rest(_b, ["rest"]);
    const _c = extractPaddingProps(withoutMargins), { rest: withoutPaddings } = _c, paddings = __rest(_c, ["rest"]);
    const _d = extractDimensionProps(withoutPaddings), { rest } = _d, dimensions = __rest(_d, ["rest"]);
    return (React.createElement(Root, Object.assign({ "data-testid": 'tend-ui-paragraph' }, rest, margins, paddings, dimensions, { ref: ref, "$color": $color, "$whiteSpace": whiteSpace, "$textAlign": textAlign, "$size": size, "$uppercase": uppercase, "$fontWeight": fontWeight, className: ['tend-ui-typography-paragraph', className].filter(Boolean).join(' '), component: 'p' })));
});
Paragraph.displayName = 'Paragraph';

export { Paragraph };
//# sourceMappingURL=Paragraph.js.map
